<script setup lang="ts">
import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import jaJP from "@/locales/ja-JP.json";
import enUS from "@/locales/en-US.json";
import { useTaskStore } from "@/store/task";
import {
  isImplementsDailyTaskCompleteInfo,
  isImplementsWeeklyTaskCompleteInfo,
  TaskCompleteInfo,
  TaskKind
} from "@/@types/Task";
import ToggleButton from "./base/ToggleButton.vue";
import { getTodayString } from "@/utils/CommonUtils";

type MessageSchema = typeof jaJP;

const { t } = useI18n<{
  message: MessageSchema
}, "ja-JP" | "en-US">({
  inheritLocale: true,
  messages: {
    "ja-JP": jaJP,
    "en-US": enUS,
  }
});

interface Prop {
  task: TaskCompleteInfo;
}

const props = defineProps<Prop>();

const taskStore = useTaskStore();

const task = ref(props.task);

const updateTaskStore = (kind: TaskKind, id: string, value: boolean, dateLineHour: number) => {
  const today = getTodayString(dateLineHour);
  console.log(kind +" task[" + id + "].newValue: " + value);
  const completeAt = value ? today : "";
  switch (kind) {
    case "daily":
      taskStore.updateDaily(id, value, completeAt);
      break;
    case "weekly":
      taskStore.updateWeekly(id, value, completeAt);
      break;
  }
};

watch(() => task.value.completed, () => {
  const updatedTask = task.value;
  if (isImplementsDailyTaskCompleteInfo(updatedTask)) {
    updateTaskStore("daily", updatedTask.id, updatedTask.completed, updatedTask.dateLineHour);
  } else if (isImplementsWeeklyTaskCompleteInfo(updatedTask)) {
    updateTaskStore("weekly", updatedTask.id, updatedTask.completed, updatedTask.dateLineHour);
  } else {
    return;
  }
});
</script>

<template>
  <div>
    <ToggleButton v-model="task.completed" />
    <span class="label">{{ t("tasks." + task.id) }}</span>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/sass/mixin.scss";

.label {
  margin-left: 1rem;
}

@include mq(sp) {
  .label {
    margin-left: .5rem;
    display: block;
    width: 100%;
  }
}
</style>
